import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "./chunks/tslib.es6.js";
import e from "./Color.js";
import o from "./core/Collection.js";
import { referenceSetter as t } from "./core/collectionUtils.js";
import { typeCast as s } from "./core/compilerUtils.js";
import a from "./core/Error.js";
import { JSONSupportMixin as i } from "./core/JSONSupport.js";
import { clone as n } from "./core/lang.js";
import l from "./core/Loadable.js";
import { loadAll as p } from "./core/loadAll.js";
import c from "./core/Logger.js";
import { throwIfAborted as u, eachAlways as y } from "./core/promiseUtils.js";
import { property as d } from "./core/accessorSupport/decorators/property.js";
import { Integer as m } from "./core/accessorSupport/ensureType.js";
import { subclass as f } from "./core/accessorSupport/decorators/subclass.js";
import { writer as h } from "./core/accessorSupport/decorators/writer.js";
import { NavigationConstraint as v } from "./ground/NavigationConstraint.js";
import { transparencyToOpacity as g, opacityToTransparency as j } from "./webdoc/support/opacityUtils.js";

var _w;

var C = c.getLogger("esri.Ground");

var S = _w = /*#__PURE__*/function (_i) {
  _inherits(w, _i);

  var _super = _createSuper(w);

  function w(r) {
    var _this;

    _classCallCheck(this, w);

    _this = _super.call(this, r), _this.opacity = 1, _this.surfaceColor = null, _this.navigationConstraint = null, _this.layers = new o();

    var e = function e(r) {
      r.parent && r.parent !== _assertThisInitialized(_this) && "remove" in r.parent && r.parent.remove(r), r.parent = _assertThisInitialized(_this), "elevation" !== r.type && "base-elevation" !== r.type && C.error("Layer '".concat(r.title, ", id:").concat(r.id, "' of type '").concat(r.type, "' is not supported as a ground layer and will therefore be ignored. Only layers of type 'elevation' are supported."));
    },
        t = function t(r) {
      r.parent = null;
    };

    _this.layers.on("after-add", function (r) {
      return e(r.item);
    }), _this.layers.on("after-remove", function (r) {
      return t(r.item);
    });
    return _this;
  }

  _createClass(w, [{
    key: "initialize",
    value: function initialize() {
      this.when().catch(function (r) {
        C.error("#load()", "Failed to load ground", r);
      }), this.resourceInfo && this.read(this.resourceInfo.data, this.resourceInfo.context);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var r = this.layers.removeAll();

      var _iterator = _createForOfIteratorHelper(r),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;

          _e.destroy();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.layers.destroy();
    }
  }, {
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(r) {
      return r && "resourceInfo" in r && (this._set("resourceInfo", r.resourceInfo), delete (r = _objectSpread({}, r)).resourceInfo), r;
    }
  }, {
    key: "layers",
    set: function set(r) {
      this._set("layers", t(r, this._get("layers")));
    }
  }, {
    key: "writeLayers",
    value: function writeLayers(r, e, o, t) {
      var i = [];
      r ? (t = _objectSpread(_objectSpread({}, t), {}, {
        layerContainerType: "ground"
      }), r.forEach(function (r) {
        if ("write" in r) {
          var _e2 = {};
          s(r)().write(_e2, t) && i.push(_e2);
        } else t && t.messages && t.messages.push(new a("layer:unsupported", "Layers (".concat(r.title, ", ").concat(r.id, ") of type '").concat(r.declaredClass, "' cannot be persisted in the ground"), {
          layer: r
        }));
      }), e.layers = i) : e.layers = i;
    }
  }, {
    key: "load",
    value: function load(r) {
      return this.addResolvingPromise(this._loadFromSource(r)), Promise.resolve(this);
    }
  }, {
    key: "loadAll",
    value: function loadAll() {
      var _this2 = this;

      return p(this, function (r) {
        r(_this2.layers);
      });
    }
  }, {
    key: "queryElevation",
    value: function () {
      var _queryElevation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r, e) {
        var _yield$import, o, t, s;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.load({
                  signal: null == e ? void 0 : e.signal
                });

              case 2:
                _context.next = 4;
                return import("./layers/support/ElevationQuery.js");

              case 4:
                _yield$import = _context.sent;
                o = _yield$import.ElevationQuery;
                u(e);
                t = new o(), s = this.layers.filter(L).toArray();
                return _context.abrupt("return", t.queryAll(s, r, e));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function queryElevation(_x, _x2) {
        return _queryElevation.apply(this, arguments);
      }

      return queryElevation;
    }()
  }, {
    key: "createElevationSampler",
    value: function () {
      var _createElevationSampler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(r, e) {
        var _yield$import2, o, t, s;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.load({
                  signal: null == e ? void 0 : e.signal
                });

              case 2:
                _context2.next = 4;
                return import("./layers/support/ElevationQuery.js");

              case 4:
                _yield$import2 = _context2.sent;
                o = _yield$import2.ElevationQuery;
                u(e);
                t = new o(), s = this.layers.filter(L).toArray();
                return _context2.abrupt("return", t.createSamplerAll(s, r, e));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createElevationSampler(_x3, _x4) {
        return _createElevationSampler.apply(this, arguments);
      }

      return createElevationSampler;
    }()
  }, {
    key: "clone",
    value: function clone() {
      var r = {
        opacity: this.opacity,
        surfaceColor: n(this.surfaceColor),
        navigationConstraint: n(this.navigationConstraint),
        layers: this.layers.slice()
      };
      return this.loaded && (r.loadStatus = "loaded"), new _w({
        resourceInfo: this.resourceInfo
      }).set(r);
    }
  }, {
    key: "read",
    value: function read(r, e) {
      this.resourceInfo || this._set("resourceInfo", {
        data: r,
        context: e
      }), _get(_getPrototypeOf(w.prototype), "read", this).call(this, r, e);
    }
  }, {
    key: "_loadFromSource",
    value: function _loadFromSource(r) {
      var e = this.resourceInfo;
      return e ? this._loadLayersFromJSON(e.data, e.context, r) : Promise.resolve(null);
    }
  }, {
    key: "_loadLayersFromJSON",
    value: function _loadLayersFromJSON(r, e, o) {
      var _this3 = this;

      var t = e && e.origin || "web-scene",
          s = e && e.portal || null,
          a = e && e.url || null;
      return import("./layers/support/layersCreator.js").then(function (_ref) {
        var e = _ref.populateOperationalLayers;
        u(o);
        var i = [];

        if (r.layers && Array.isArray(r.layers)) {
          var _o = {
            context: {
              origin: t,
              url: a,
              portal: s,
              layerContainerType: "ground"
            },
            defaultLayerType: "ArcGISTiledElevationServiceLayer"
          };
          i.push(e(_this3.layers, r.layers, _o));
        }

        return y(i);
      }).then(function () {});
    }
  }]);

  return w;
}(i(l));

function I(r) {
  return r && "createElevationSampler" in r;
}

function L(r) {
  return "elevation" === r.type || I(r);
}

r([d({
  json: {
    read: !1
  }
})], S.prototype, "layers", null), r([h("layers")], S.prototype, "writeLayers", null), r([d({
  readOnly: !0
})], S.prototype, "resourceInfo", void 0), r([d({
  type: Number,
  nonNullable: !0,
  range: {
    min: 0,
    max: 1
  },
  json: {
    type: m,
    read: {
      reader: g,
      source: "transparency"
    },
    write: {
      writer: function writer(r, e) {
        e.transparency = j(r);
      },
      target: "transparency"
    }
  }
})], S.prototype, "opacity", void 0), r([d({
  type: e,
  json: {
    type: [m],
    write: function write(r, e) {
      e.surfaceColor = r.toJSON().slice(0, 3);
    }
  }
})], S.prototype, "surfaceColor", void 0), r([d({
  type: v,
  json: {
    write: !0
  }
})], S.prototype, "navigationConstraint", void 0), S = _w = r([f("esri.Ground")], S);
var A = S;
export { A as default };